import { createFileRoute, redirect } from "@tanstack/react-router";
import { DEFAULT_HOME } from "@/components/layout/nav.ts";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: DEFAULT_HOME, replace: true });
  },
});
